/**
 * 审批差异对比高亮通用工具 (Approval Diff Highlighting Utility)
 * 用于在审批页左右并排表单及明细表中识别并高亮被修改、新增、删除的字段与行。
 */

export function normalizeDiffValue(val: any): string {
  if (val === null || val === undefined || val === '') {
    return ''
  }
  if (Array.isArray(val)) {
    return JSON.stringify(val)
  }
  if (typeof val === 'number') {
    return String(val)
  }
  if (typeof val === 'string') {
    const trimmed = val.trim()
    if (trimmed !== '' && !Number.isNaN(Number(trimmed))) {
      return String(Number(trimmed))
    }
    return trimmed
  }
  if (typeof val === 'object') {
    return JSON.stringify(val)
  }
  return String(val)
}

/**
 * 判断两个对象在指定字段上是否存在差异
 */
export function isFieldChanged(
  source: Record<string, any> | null | undefined,
  compare: Record<string, any> | null | undefined,
  fieldKey: string
): boolean {
  if (!source || !compare) {
    return false
  }
  return normalizeDiffValue(source[fieldKey]) !== normalizeDiffValue(compare[fieldKey])
}

/**
 * 计算两个对象之间所有发生变更的字段集合
 */
export function computeChangedKeys(
  source: Record<string, any> | null | undefined,
  compare: Record<string, any> | null | undefined,
  keys?: string[]
): Set<string> {
  const changed = new Set<string>()
  if (!source || !compare) {
    return changed
  }
  const checkKeys = keys || Array.from(new Set([...Object.keys(source), ...Object.keys(compare)]))
  for (const key of checkKeys) {
    if (isFieldChanged(source, compare, key)) {
      changed.add(key)
    }
  }
  return changed
}

/**
 * 判断业务明细行中的原价与现价是否发生变化
 */
export function isPriceChanged(
  row: Record<string, any> | null | undefined,
  oldKey = 'price',
  newKey = 'newPrice'
): boolean {
  if (!row) {
    return false
  }
  const oldVal = row[oldKey]
  const newVal = row[newKey]
  if (oldVal === undefined || newVal === undefined) {
    return false
  }
  return Number(oldVal) !== Number(newVal)
}
